import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'nprogress/nprogress.css';
import './assets/css/prism.css';
import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as serviceWorker from './serviceWorker';
import { SettingsProvider } from './context/SettingsContext';
import { configureStore } from './store';
import { restoreSettings } from './utils/settings';

import App from './App';

enableES5();

const { store } = configureStore();
const settings = restoreSettings();

ReactDOM.render(
  <Provider store={store}>
      <SettingsProvider settings={settings}>
        <GoogleOAuthProvider clientId="1082026622085-5rc0ecq01kcev4preabeprn2mu9r5uo8.apps.googleusercontent.com"> {/* TODO - Provide clientId from the project */}
          <App />
        </GoogleOAuthProvider>
      </SettingsProvider>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
